import $ from 'jquery';
import { getInputValue } from '../utils/input';
var ProductType;
(function (ProductType) {
    ProductType["Regular"] = "regular";
    ProductType["StarterKit"] = "starter_kit";
})(ProductType || (ProductType = {}));
const ELEMENT_SELECTOR = '.js__filter-promotions-by-products';
export class FilterPromotionsByProduct {
    static init($root = $('body')) {
        const $element = $root.find(ELEMENT_SELECTOR);
        if (!$element.length) {
            return;
        }
        this.addActions($element);
    }
    static addActions($filterElement) {
        $filterElement.each((index, element) => {
            const $element = $(element);
            $element.on('change', e => {
                const $element = $(e.currentTarget);
                const value = getInputValue($element);
                const $promotionElement = $element
                    .closest('.js__collection-item-row')
                    .find($($element.data('filter-dropdown')));
                const productCode = $element.parent().find(`[data-value="${value}"]`).data('option-value');
                const productType = $element.parent().find(`[data-value="${value}"]`).data('product-type');
                $promotionElement.find('select option').each((index, element) => {
                    this.hideFilteredOptions($(element), $promotionElement, productCode);
                });
                this.togglePromotionRequired($promotionElement, productType);
                this.initDropdown($promotionElement);
                this.clearEmptyDropdown($promotionElement);
                $promotionElement.dropdown('refresh');
            });
            $element.trigger('change');
            const $promotionElement = $element.closest('.js__collection-item-row').find($($element.data('filter-dropdown')));
            $('body').on('blur', 'input.search', () => {
                this.clearEmptyDropdown($promotionElement);
            });
        });
    }
    static clearEmptyDropdown($select) {
        if ($select.parent().find('.item').length && !$select.parent().find('.item:not([data-filtered="1"])').length) {
            $select.dropdown('clear');
        }
    }
    static togglePromotionRequired($promotionField, productType) {
        const $field = $promotionField.closest('.field');
        $field.toggleClass('required', productType == ProductType.StarterKit);
    }
    static initDropdown($promotionElement) {
        const options = {
            fullTextSearch: true,
        };
        const $promotionSelect = $promotionElement.find('select');
        $promotionSelect.addClass('disable-select');
        if ($promotionSelect.is('[data-clearable]')) {
            options.clearable = true;
        }
        $promotionElement.dropdown(options);
    }
    static hideFilteredOptions($option, $promotionElement, productCode) {
        const productCodes = String($option.data('product-codes')).split(',');
        const $dropdownItem = $promotionElement.find(`[data-value="${$option.attr('value')}"]`);
        if (productCodes.includes(productCode)) {
            $dropdownItem.show();
            $dropdownItem.attr('data-filtered', '0');
        }
        else {
            $dropdownItem.hide();
            $dropdownItem.attr('data-filtered', '1');
        }
    }
}
